import React, { useCallback, useEffect, useState } from 'react';
import imgurl from '../assests/images/imgurl'
import { Typography } from '@mui/material';
import { Link } from "react-router-dom";
import i18next from 'i18next';
import { useSelector } from 'react-redux';


function Footer() {
    const [isMobile, setIsMobile] = useState(false);
    const locale = useSelector((state) => state.language.langData)

    const proceedToNxtPrivacy = useCallback(() => {
        window.open(`https://aloxa.ai/privacy-policy?lang=${locale}`, "_blank");
      }, [locale]);

    const proceedToNxtService = useCallback(() => {
        window.open(`https://aloxa.ai/terms-of-service?lang=${locale}`, "_blank");
      }, [locale]);

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, [isMobile]);

  return (
    <div className={!isMobile ? 'footerSection mt-40px' : 'footerSection'}>

        <div className='footerDetails'>

           <div className='logoAddress'>
           
           <div className='footerLogo'>
            <img src={imgurl.hairlossaiLogo}></img>
           </div>

           <div className='footerAddress'>
            <Typography>Centa  Biotech SL,Alameda Principal 11, </Typography>
            <Typography>29001 Malaga, Spain. </Typography>
           </div>

        
           </div>
           <div className="mt-5px footerDiv">
           <div>
            <Typography className='footerName rightsText'>{i18next.t("@2025 Alopexia. All rights reserved.")}</Typography>
            </div>

            <div className='footerLinks'>
            
            <div>
            <Link to="https://alopexia.com/policies/privacy-policy" className="linkName">
            <Typography className="footerName">• {i18next.t("Privacy Policy")}</Typography>
            </Link>
            </div>
            <div className='text-left'>
            <Link to="https://alopexia.com/policies/terms-of-service" className="linkName">
            <Typography className="footerName">• {i18next.t("Terms of Service")}</Typography>
            </Link>
            </div>
            <div>
            <Link to="https://alopexia.com/policies/contact-information" className="linkName">
            <Typography className="footerName">• {i18next.t("Contact Information")}</Typography>
            </Link>
            </div>
            {/* <div>
            <Link to="https://alopexia.com/policies/refund-policy" className="linkName">
            <Typography className="footerName">• {i18next.t("Refund Policy")}</Typography>
            </Link>
            </div>
            <div>
            <Link to="" className="linkName">
            <Typography className="footerName">• {i18next.t("Cookie Preferences")}</Typography>
            </Link>
            </div>
            <div>
            <Link to="/feedback" className="linkName">
            <Typography className="footerName">• {i18next.t("Feedback Form")}</Typography>
            </Link>
            </div> */}
            </div>
        {/* <Grid item xs={6}></Grid> */}

        
            <div className='centabioLink'>
            <Link to="https://www.centabio.com/">www.centabio.com</Link>
            </div>
           </div>

        </div>
      
    </div>
  )
}

export default Footer
